import { render, staticRenderFns } from "./MedPrescribingInfo.vue?vue&type=template&id=ab961e0a&scoped=true&"
import script from "./MedPrescribingInfo.vue?vue&type=script&lang=ts&"
export * from "./MedPrescribingInfo.vue?vue&type=script&lang=ts&"
import style1 from "./MedPrescribingInfo.vue?vue&type=style&index=1&id=ab961e0a&lang=scss&rel=stylesheet&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab961e0a",
  null
  
)

export default component.exports